const CONSTANTS = {
  GET_SEND_CALL_REQUEST: "GET_SEND_CALL_REQUEST",
  SET_CALL_REQUEST_HAS_BEEN_SENT: "SET_CALL_REQUEST_HAS_BEEN_SENT",
  GET_SERVICE_TOKEN: "GET_SERVICE_TOKEN",
  SET_SERVICE_TOKEN: "SET_SERVICE_TOKEN",
  SET_CALL_REQUEST_LOADING: "SET_CALL_REQUEST_LOADING",
};

export default CONSTANTS;
